// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__1ZSX0","sendOtp":"AuthorizeToLogin_sendOtp__2jMka"};